/**
 * Icône avec couleur de branding automatique pour les formulaires publics (référent + candidat)
 */
import { useReferentBrandingColors } from '@/hooks/useReferentBrandingColors';
import { LucideIcon } from 'lucide-react';

interface BrandingSettings {
  enabled: boolean;
  logo_url?: string;
  primary_color?: string;
}

interface BrandedIconProps {
  Icon: LucideIcon;
  branding?: BrandingSettings | null;
  variant?: 'primary' | 'success' | 'muted';
  className?: string;
  size?: number;
}

export const BrandedIcon = ({ 
  Icon, 
  branding, 
  variant = 'primary',
  className,
  size,
  ...props 
}: BrandedIconProps) => {
  const colors = useReferentBrandingColors(branding);
  
  const colorMap = {
    primary: colors.primary,
    success: colors.success,
    muted: '#6B7280'
  };
  
  return (
    <Icon 
      className={className}
      size={size}
      style={{ color: colorMap[variant] }}
      {...props}
    />
  );
};